
import _ from 'underscore'

const TagsMixin = {

  initialize(attributes, options = {}) {
    // Unwrap tags into a tag{name} property. This allows for faster matching
    // using Backbone methods (where, find, get, etc).

    if (attributes.tags) {
      _.each(attributes.tags, function (value, key) {
        attributes.tags[key] = value.toString()
        attributes['tag' + key] = value.toString()
      })

      this.set(attributes, {silent: true})
    }
  },

  tags() {
    return this.get('tags')
  }
}

export default TagsMixin